  /* eslint-disable */
 //判断客户端是android还是ios
 export function getDeviceType() {
   //var result = "";
   let u = navigator.userAgent;
   let myOS = "android";
   if (u.indexOf('iPhone') > -1  ||  u.indexOf('iPad') > -1) { // 苹果手机
     myOS = "IOS";
   }
   return myOS;
 }
 export function getTextImgUrl() {
  //调用相册或拍照
  if (getDeviceType() == "android") {
    //安卓
    window.android.getInfo(102);
  } else {
    //IOS
    window.webkit.messageHandlers.getImgs.postMessage("1");
  }
}